import { NgModule } from '@angular/core';
import { LibraryComponent } from './components/library/library.component';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';



@NgModule({
  declarations: [LibraryComponent], imports: [SharedModule, CoreModule]
})
export class LibraryModule { }
